// import storage from './storage'

export default {
  set (data) {
    // storage.set(window.location.href, data)
  },
  get () {
    // return storage.get(window.location.href)
  }
}



/** WEBPACK FOOTER **
 ** ./src/libs/cache.js
 **/